import { SettingsService } from './settings.service';
import { ModuleWithProviders, NgModule} from '@angular/core';
import { IParameters, APP_DI_SETTINGS } from './parameters.interface';

@NgModule({
    imports: [ ],
    providers: [
        SettingsService
    ]
})
export class SettingsModule {
    public static forRoot( config?: IParameters ): ModuleWithProviders<any> {
        return {
            ngModule: SettingsModule,
            providers: [
                { provide: APP_DI_SETTINGS, useValue: config }
            ]
        };
    }
}
